// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay-loading[data-v-74849697]{color:#fff;font-size:40px}`, "",{"version":3,"sources":["webpack://./client/components/OverlayLoading.vue"],"names":[],"mappings":"AAGA,kCACE,UAAA,CACA,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
